<template>
  <div class="d-flex flex-column justify-content-center login">
    <div class="form">
      <img class="logo" :src="require('../assets/images/logo-brand.png')" />
      <h4 class="font-weight-bold" v-if="!$route.query.token">
        Reset Password
      </h4>
      <h4 class="font-weight-bold" v-if="$route.query.token">
        Buat Password Baru
      </h4>
      <p class="text-muted text-sm" v-if="!$route.query.token">
        Masukkan email anda, link reset password akan dikirimkan ke email anda
      </p>
      <ValidationObserver ref="form1" v-slot="{ handleSubmit }">
        <form
          @submit.prevent="handleSubmit(onSubmit)"
          autocomplete="off"
          class="p-0"
          id="form"
        >
          <b-form-group label="Email" v-if="!$route.query.token">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <i class="ri-mail-line"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                type="email"
                placeholder="email@rbs.com"
                v-model="email"
                required
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>

          <b-form-group v-if="$route.query.token" label="Password">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <i class="ri-lock-password-line"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                type="password"
                placeholder="Masukkan Password Baru"
                v-model="password"
                required
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>

          <b-form-group v-if="$route.query.token" label="Konfirmasi Password">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <i class="ri-lock-password-line"></i>
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                type="password"
                placeholder="Konfirmasi Password Baru"
                v-model="retype_password"
                required
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>

          <b-form-group>
            <b-button
              :disabled="isLoading"
              variant="primary"
              type="submit"
              class="mr-3"
            >
              <i class="ri-login-circle-line"></i> Reset Password
            </b-button>
          </b-form-group>
        </form>
      </ValidationObserver>
    </div>
    <img
      v-if="false"
      :src="require('../assets/images/frame-login.png')"
      class="login-frame"
    />
    <img
      v-if="false"
      :src="require('../assets/images/frame-login-1.png')"
      class="login-frame-1"
    />
  </div>
</template>
<script>
import "./login/login.scss";
import _ from "lodash";
export default {
  name: "reset-password-page",
  data() {
    return {
      email: null,
      password: null,
      retype_password: null,
      isLoading: false,
      isMobile: window.innerWidth <= 760,
    };
  },

  mounted() {
    addEventListener("resize", () => {
      this.isMobile = window.innerWidth <= 760;
    });
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.form1.validate();
      if (!isValid) return;

      this.isLoading = true;

      if (this.$route.query.token) {
        //create password
        this.$_api
          .resetPassword(this.$route.query.token, {
            password: this.password,
            retype_password: this.retype_password,
          })
          .then(() => {
            this.isLoading = false;
            this.$_alert
              .success(
                "Berhasil",
                `Password anda berhasil direset, silahkan login`,
                "center",
                true,
                10000
              )
              .then((response) => {
                this.isLoading = false;
                this.$router.replace({
                  path: "/login",
                  query: {},
                });
              })
              .catch((err) => {
                this.isLoading = false;
                this.$alert.error(err);
              });
          })

          .catch((err) => {
            this.isLoading = false;
            this.$alert.error(err);
          });
      } else {
        this.$_api
          .post("/password/forgot", { email: this.email })
          .then(() => {
            this.isLoading = false;
            this.$_alert
              .success(
                "Berhasil",
                `Link reset password dikirimkan ke email ${this.email}, silahkan cek email anda`,
                "center",
                true,
                10000
              )
              .then((response) => {
                if (response.isConfirmed) {
                  this.isLoading = false;
                  this.$router.replace({
                    path: "/login",
                    query: {},
                  });
                }
              })
              .catch((err) => {
                this.isLoading = false;
                this.$alert.error(err);
              });
          })
          .catch((err) => {
            this.isLoading = false;
            this.$alert.error(err);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/default-page/forgot-password.vue